<template>
  <section class="mb-20">
    <h2
      class="font-roboto text-2xl font-bold border-b border-royal-blue-20 pb-4 mb-4"
      id="themed-collection-option-required">
      Themed collection
    </h2>
    <p class="mb-4">
      Is this manuscript submission in response to a themed collection invitation?
    </p>
    <FormRadio
      inputId="themedCollectionYes"
      labelText="Yes"
      name="group-1"
      value="yes"
      v-model="response"
      :label-custom-css-classes="['font-bold']"
    />

    <div
      v-if="isYesSelected"
      class="ps-[2.39em]">
      <FormTextArea
        id="mandatoryTextInput"
        label="The themed collection title is"
        class="data-hj-suppress"
        type="text"
        v-model="title"
        :rows="2"
      />
    </div>

    <div class="mt-2">
      <FormRadio
        inputId="themedCollectionNo"
        labelText="No"
        name="group-1"
        value="no"
        v-model="response"
        :label-custom-css-classes="['font-bold']"
      />
      <InlineWarningMessage
        v-if="error"
        :errorMessage="error"
        class="mt-4"
        errorTestId="themed-collection-option"
      />
    </div>
  </section>
</template>

<script setup lang="ts">
import { useStore } from 'vuex'
import { ref, watch } from 'vue'
import FormRadio from '../ui-components/FormRadio.vue'
import FormTextArea from '../ui-components/FormTextArea.vue'
import InlineWarningMessage from '../common/InlineWarningMessage.vue'
import { validateField } from '@/services/validation/utils'
import limits from '../../constants/limits'

const store = useStore()
const response = ref(store.state.activeSubmission.themedCollectionResponse || '')
const title = ref(store.state.activeSubmission.themedCollectionTitle || '')
const isYesSelected = ref(response.value === 'yes')

const props = defineProps<{ error?: string }>()
const emit = defineEmits(['clear-error', 'update-error'])

watch(title, async (newTitle) => {
  store.commit('setThemedCollectionTitle', newTitle)

  if (newTitle !== '' && response.value !== 'yes') {
    response.value = 'yes'
  }
  await store.dispatch('setThemedCollectionSelection', response.value || 'no')
  const result = await validateField(
    store.state.activeSubmission.themedCollectionTitle,
    `themed-collection-option-required|max-characters-length:${limits.themedCollection.characters.title},Themed collection title must not exceed`,
  )
  if (result?.errors?.length) {
    emit('update-error', result.errors[0])
  }
  else {
    emit('clear-error')
  }
})

watch(response, async (newResponse) => {
  if (newResponse === 'no') {
    emit('clear-error')
    title.value = ''
    store.commit('setThemedCollectionTitle', '')
    await store.dispatch('setThemedCollectionSelection', 'no')
    isYesSelected.value = false
  }
  else {
    await store.dispatch('setThemedCollectionSelection', 'yes')
    isYesSelected.value = true
    if (newResponse === 'yes' && props.error) {
      emit('update-error')
    }
  }
})
</script>
